
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import menuprincipal from './menu/menu.vue';
    import pedidos from './pedidos/pedidos.vue';
    import guardar from './menu/guardar.vue';
    import finalizar from './menu/finalizar.vue';
    import eliminar from './menu/eliminar.vue';
    import nuevo from './menu/nuevo.vue';
    import configuracion from './menu/configuracion.vue';

    import articulos from './articulos/articulos.vue';
    import clientes from './clientes/clientes.vue';
    import editar_cliente from './clientes/editar/editar_cliente.vue';
    import editar_envio from './envio/editar/editar_envio.vue';
    import vendedores from './vendedores/vendedores.vue';
    import cantidad from './cantidad/cantidad.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            menuprincipal,
            pedidos,
            nuevo,
            finalizar,
            guardar,
            eliminar,
            configuracion,
            articulos,
            cantidad,
            clientes,
            vendedores,
            editar_cliente,
            editar_envio,

        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;
        public get BarraIzquierda() { return this.Controlador.Vista.BarraIzquierda; }
        public get SubModo() { return this.BarraIzquierda.SubModo; }
        public set SubModo( x: string ) { this.BarraIzquierda.SubModo = x; }
        public get Modo() { return this.BarraIzquierda.Modo; }
        public set Modo( x: string ) { this.BarraIzquierda.Modo = x; }

        public get Abierto() { return this.BarraIzquierda.Abierto; }
        public set Abierto( x: boolean ) { this.BarraIzquierda.Abierto = x; }

        public get Anchura() { return this.BarraIzquierda.Anchura.Espacio; }
        public set Anchura( x: string | number ) { this.BarraIzquierda.Anchura.Espacio = x; }

        public get Altura() { return this.BarraIzquierda.Altura.Espacio; }
        public set Altura( x: string | number ) { this.BarraIzquierda.Altura.Espacio = x; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        mounted()
        {

            this.Anchura = '400px';
            this.Abierto = true;
            this.Eventos.push( this.BarraIzquierda.onAbierto.subscribe( () =>
            {

                //if ( !this.Abierto )
                //    this.EspacioDerecha= 0;

            } ) );


            this.Eventos.push( this.BarraIzquierda.onModo.subscribe( () =>
            {
                if ( this.Modo )
                {
                    this.Controlador.Vista.BarraIzquierda.Estado = '';
                    this.Controlador.Vista.BarraIzquierda.Anchura.Espacio = '0px !important';
                    //ControladorPrincipal.Vista.OcultarMenu();
                    this.Abierto = true;
                } else
                {
                    //ControladorPrincipal.Vista.MenuOculto = false;
                    this.Abierto = false;
                }



            } ) );


        }

    }
